import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MainRoute from './navigation/MainRoute';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './navigation/AuthContext';
import { SessionManager } from './utils/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MainRoute />
      <SessionManager />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
